import _ from 'lodash';
import { Helper, DateHelper } from '@hems/util';
function getRoundDownedNumber(value, decimal) {
    if (value === null || value === undefined)
        return null;
    return Number(Helper.toFixed(value, decimal));
}
export function getOverviewCardData(locale, data, t, hasPV, hasESS) {
    let lastYearData = [
        {
            id: 'generation',
            data: data ? (data.gen_data ? getRoundDownedNumber(data.gen_data[0], 2) : null) : null,
            title: t('device.produced'),
            btnPath: 'PvGeneration',
        },
        {
            id: 'consumption',
            data: data ? (data.con_data ? getRoundDownedNumber(data.con_data[0], 2) : null) : null,
            title: t('device.consumed'),
            btnPath: 'Consumption',
        },
        {
            id: 'feedin',
            data: data ? (data.feedin_data ? getRoundDownedNumber(data.feedin_data[0], 2) : null) : null,
            title: t('device.exported'),
            btnPath: 'Grid',
        },
        {
            id: 'demand',
            data: data ? (data.demand_data ? getRoundDownedNumber(data.demand_data[0], 2) : null) : null,
            title: t('device.imported'),
            btnPath: 'Grid',
        },
        {
            id: 'charging',
            data: data ? (data.btc_data ? getRoundDownedNumber(data.btc_data[0], 2) : null) : null,
            title: t('device.charged'),
            btnPath: 'Battery',
        },
        {
            id: 'discharging',
            data: data ? (data.btd_data ? getRoundDownedNumber(data.btd_data[0], 2) : null) : null,
            title: t('device.discharged'),
            btnPath: 'Battery',
        },
    ];
    let thisYearData = [
        {
            id: 'generation',
            data: data ? (data.gen_data ? getRoundDownedNumber(data.gen_data[1], 2) : null) : null,
            title: t('device.produced'),
            btnPath: 'PvGeneration',
            detailMessageInfo: {
                isInfo: data?.third_party === 'Y',
                message: 'The real-time production power is the sum of PV module with Q.HOME CORE and the 3rd Party PV module.',
            },
        },
        {
            id: 'consumption',
            data: data ? (data.con_data ? getRoundDownedNumber(data.con_data[1], 2) : null) : null,
            title: t('device.consumed'),
            btnPath: 'Consumption',
        },
        {
            id: 'feedin',
            data: data ? (data.feedin_data ? getRoundDownedNumber(data.feedin_data[1], 2) : null) : null,
            title: t('device.exported'),
            btnPath: 'Grid',
        },
        {
            id: 'demand',
            data: data ? (data.demand_data ? getRoundDownedNumber(data.demand_data[1], 2) : null) : null,
            title: t('device.imported'),
            btnPath: 'Grid',
        },
        {
            id: 'charging',
            data: data ? (data.btc_data ? getRoundDownedNumber(data.btc_data[1], 2) : null) : null,
            title: t('device.charged'),
            btnPath: 'Battery',
        },
        {
            id: 'discharging',
            data: data ? (data.btd_data ? getRoundDownedNumber(data.btd_data[1], 2) : null) : null,
            title: t('device.discharged'),
            btnPath: 'Battery',
        },
    ];
    if (!hasPV) {
        lastYearData = _.filter(lastYearData, (v) => v.btnPath !== 'PvGeneration');
        thisYearData = _.filter(thisYearData, (v) => v.btnPath !== 'PvGeneration');
    }
    if (!hasESS) {
        lastYearData = _.filter(lastYearData, (v) => v.btnPath !== 'Battery');
        thisYearData = _.filter(thisYearData, (v) => v.btnPath !== 'Battery');
    }
    const collectdDate = {
        lastYearDate: DateHelper.getLocalDate(data?.colec_time[0] ?? '', { isMonthly: true }),
        thisYearDate: DateHelper.getLocalDate(data?.colec_time[1] ?? '', { isMonthly: true }),
    };
    return { lastYear: lastYearData, thisYear: thisYearData, date: collectdDate };
}
